import { post } from '../service/request';

export function sendEmail(params) {
  return post('/crm-data/a/official/email/send', params);
}